var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{staticClass:"sidebar-button",class:{ [_vm.size]: true, 'pulse-button': _vm.pulse, [_vm.type]: true },attrs:{"loading":_vm.loading,"type":_vm.type,"icon":_vm.icon,"size":_vm.size,"round":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }